import { GB, DE, ES, GR, KR, JP, TR, AR, CN, IT } from "../../../../../assets/--native/index";
import { View, Image } from 'react-native';
import styles from "../../../../../stylesheet";
const lang = [
  {
    flag: 'GB',
    language: 'English',
    label: 'English',
    languageCode: 'en-GB',
    value: 'en-GB',
    source: <Image source={require("@assets/--native/Flags/great-britain-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: "FR",
    language: 'French',
    label: 'French',
    languageCode: 'fr',
    value: 'fr',
    source: <Image source={require("@assets/--native/Flags/france-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'DE',
    language: 'Deutsch',
    label: 'Deutsch',
    languageCode: 'de',
    value: 'de',
    source: <Image source={require("@assets/--native/Flags/germany-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'ES',
    language: 'Espanol',
    label: 'Espanol',
    languageCode: 'es',
    value: 'es',
    source: <Image source={require("@assets/--native/Flags/spain-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'GR',
    language: 'Greek',
    label: 'Greek',
    languageCode: 'el',
    value: 'el',
    source: <View style={styles.flagContainer}><GR style={styles.flagContainer} /></View>,
  },
  {
    flag: 'JP',
    language: 'Japanese',
    label: 'Japanese',
    languageCode: 'ja',
    value: 'ja',
    source: <Image source={require("@assets/--native/Flags/japan-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'TR',
    language: 'Turkish',
    label: 'Turkish',
    languageCode: 'tk',
    value: 'tk',
    source: <Image source={require("@assets/--native/Flags/turkey-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'UAE',
    language: 'Arabic',
    label: 'Arabic',
    languageCode: 'ar',
    value: 'ar',
    source: <View style={styles.flagContainer}><AR style={styles.flagContainer} /></View>,
  },
  {
    flag: 'CN',
    language: 'Chinese',
    label: 'Chinese',
    languageCode: 'zh',
    value: 'zh',
    source: <Image source={require("@assets/--native/Flags/china-circular.svg")} style={{ width: 25, height: 25 }} />,
  },
  {
    flag: 'IT',
    language: 'Italian',
    label: 'Italian',
    languageCode: 'it',
    value: 'it',
    source: <Image source={require("@assets/--native/Flags/italy-circular.svg")} style={{ width: 25, height: 25 }} />
  },
  {
    flag: 'SK',
    language: 'Sinhala',
    label: 'Sinhala',
    languageCode: 'si',
    value: 'si',
    source: <View style={styles.flagContainer}><IT style={styles.flagContainer} /></View>
  },
  {
    flag: 'KR',
    language: 'Korean',
    label: 'Korean',
    languageCode: 'ko',
    value: 'ko',
    source: <View style={styles.flagContainer}><KR style={styles.flagContainer} /></View>
  }
];
export default lang;
